import React from 'react';
import { Box, Fab, Zoom } from '@mui/material';
import { COLORS } from '../theme';
import { SCHOOL } from '../data/siteData';
import { Icon, ring, useScrollY } from './common';

export default function FloatingActions() {
  const y = useScrollY();
  return (
    <Box sx={{ position: 'fixed', right: { xs: 16, md: 28 }, bottom: { xs: 16, md: 28 }, zIndex: 1200, display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: 'center' }}>
      <Zoom in={y > 600}>
        <Fab
          size="medium"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          sx={{ bgcolor: COLORS.navy, color: '#fff', '&:hover': { bgcolor: '#26398c' } }}
        >
          <Icon name="up" />
        </Fab>
      </Zoom>
      <Fab
        aria-label="Call or WhatsApp us"
        href={`https://wa.me/${SCHOOL.phoneRaw}`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ bgcolor: COLORS.green, color: '#fff', animation: `${ring} 1.8s ease-out infinite`, '&:hover': { bgcolor: '#2fa845' } }}
      >
        <Icon name="phone" />
      </Fab>
    </Box>
  );
}
